import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Percent, Users, Wheat } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import PayrollTab from './sales/PayrollTab';
import MatiereTab from './ratios/MatiereTab';

export default function RatiosPage() {
    const { hasPermission } = useAuth();
    const canPayroll = hasPermission('sales_payroll_view');

    return (
        <div className="space-y-4 animate-fade-in" data-testid="ratios-page">
            <div className="flex items-center gap-3">
                <Percent className="w-6 h-6 text-teal-500" />
                <h1 className="text-2xl font-bold text-slate-900">Ratios</h1>
                <span className="text-sm text-slate-500">Masse salariale et ratios matière première par site</span>
            </div>

            <Tabs defaultValue="payroll">
                <TabsList>
                    {canPayroll && (
                        <TabsTrigger value="payroll" data-testid="tab-payroll">
                            <Users className="w-4 h-4 mr-1.5" />Masse salariale
                        </TabsTrigger>
                    )}
                    <TabsTrigger value="matiere" data-testid="tab-matiere">
                        <Wheat className="w-4 h-4 mr-1.5" />Ratio matière
                    </TabsTrigger>
                </TabsList>

                <TabsContent value="payroll">
                    {canPayroll && <PayrollTab />}
                </TabsContent>

                <TabsContent value="matiere">
                    <MatiereTab />
                </TabsContent>
            </Tabs>
        </div>
    );
}
